export const appInfoBadgeDataHooks = {
    APP_INFO_BADGE: 'app-info-badge',
};
//# sourceMappingURL=data-hooks.js.map